<template>
    <main>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'users.index' }">
                    {{ $t('Users') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ id ? $t('Edit') : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="id"
                :id="'user_actions_dropdown_' + id"
                :title="$t('Actions')"
                class="ml-3"
                no-caret
                right
            >
                <template slot="button-content">
                    <fa fixed-width icon="ellipsis-v" />
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa fixed-width icon="trash" />
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>

        <b-card no-body>
            <b-card-header header-tag="nav"  v-if="id">
                <b-nav card-header tabs>
                    <b-nav-item :to="{name: 'users.show', params: { id }}" exact>
                        {{ $t('Overview') }}
                    </b-nav-item>

                    <b-nav-item :to="{name: 'users.logs', params: { id }}">
                        {{ $t('Logs') }}
                    </b-nav-item>

                    <b-nav-item v-if="$auth.check(USER_ROLES.ADMIN)" :to="{name: 'users.breaks', params: { id }}">
                        {{ $t('Breaks') }}
                    </b-nav-item>
                </b-nav>
            </b-card-header>

            <router-view />
        </b-card>
    </main>
</template>

<script>
    import deleteItem from "@/mixins/deleteItem";
    import {USER_ROLES} from '@/constants';

    export default {
        name: 'User',
        mixins: [deleteItem],
        computed: {
            USER_ROLES() {
                return USER_ROLES
            },
            resourceName() {
                return 'users'
            },
            afterDelete() {
                this.$router.push({
                    name: 'users.create',
                });
            },
        },
    };
</script>
